import adminApiClient from '../api/adminApiClient'
import type { AuditLogEntry, AuditLogCleanupResponse, PaginatedResponse, AuditAction, AuditEntityType } from '../types'

export interface AuditLogParams {
  from?: string
  to?: string
  action?: AuditAction | ''
  entityType?: AuditEntityType | ''
  adminId?: string
  page?: number
  size?: number
}

export async function getAuditLog(params: AuditLogParams): Promise<PaginatedResponse<AuditLogEntry>> {
  const query: Record<string, string> = { size: String(params.size ?? 20), page: String(params.page ?? 0) }
  if (params.from) query.from = params.from
  if (params.to) query.to = params.to
  if (params.action) query.action = params.action
  if (params.entityType) query.entityType = params.entityType
  if (params.adminId?.trim()) query.adminId = params.adminId.trim()

  const { data } = await adminApiClient.get<PaginatedResponse<AuditLogEntry>>('/audit-log', { params: query })
  return data
}

export async function cleanupAuditLog(): Promise<AuditLogCleanupResponse> {
  const { data } = await adminApiClient.delete<AuditLogCleanupResponse>('/audit-log/cleanup')
  return data
}

export async function exportAuditLogAll(params: Omit<AuditLogParams, 'page' | 'size'>): Promise<AuditLogEntry[]> {
  const { data } = await adminApiClient.get<PaginatedResponse<AuditLogEntry>>('/audit-log', {
    params: {
      ...params,
      page: 0,
      size: 10000,
    },
  })
  return data.content
}
